import register from '../../../../global/js/registry';
export default register('o-adviser', () => import(/* webpackMode: "lazy" */ './o-adviser.controller'));
